import React from 'react';
import TypeWriter from '../components/TypeWriter';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <div className="container">
        {/* Header */}
        <div className="about-header card" data-aos="fade-up" data-aos-duration="900">
          <h1>
            <TypeWriter 
              text="About SignCrypt" 
              speed={95} 
              cursorColor="white"
            />
          </h1>
          <p>Empowering inclusive communication through technology</p>
        </div>

        {/* Mission Section */}
        <div className="mission-section card" data-aos="fade-up" data-aos-delay="100" data-aos-duration="900">
          <h2 className="about-section-heading">Our Mission</h2>
          <p>
            SignCrypt is dedicated to breaking down communication barriers for the speech and 
            hearing-impaired community. We believe that everyone deserves access to secure, 
            efficient, and intuitive communication tools that adapt to their unique needs.
          </p>
        </div>

        {/* Features Overview */}
        <div className="features-overview card" data-aos="fade-up" data-aos-delay="200" data-aos-duration="900">
          <h2 className="about-section-heading">What We Offer</h2>
          <div className="features-grid">
            <div className="feature-card" data-aos="zoom-in" data-aos-delay="250" data-aos-duration="700">
              <div className="feature-icon">🤟</div>
              <h3>Sign Language Recognition</h3>
              <p>Real-time ASL gesture recognition using advanced computer vision technology</p>
            </div>
            <div className="feature-card" data-aos="zoom-in" data-aos-delay="350" data-aos-duration="700">
              <div className="feature-icon">📡</div>
              <h3>Morse Code Detection</h3>
              <p>Hand gesture-based Morse code input for alternative communication</p>
            </div>
            <div className="feature-card" data-aos="zoom-in" data-aos-delay="450" data-aos-duration="700">
              <div className="feature-icon">🔒</div>
              <h3>Secure Encryption</h3>
              <p>Military-grade encryption to protect your private communications</p>
            </div>
            <div className="feature-card" data-aos="zoom-in" data-aos-delay="550" data-aos-duration="700">
              <div className="feature-icon">🚨</div>
              <h3>Emergency SOS</h3>
              <p>Quick emergency alerts to trusted contacts when needed</p>
            </div>
          </div>
        </div>

        {/* Technology Stack */}
        <div className="tech-section card" data-aos="fade-up" data-aos-delay="300" data-aos-duration="900">
          <h2 className="about-section-heading">Technology Stack</h2>
          <div className="tech-grid">
            <div className="tech-item" data-aos="flip-left" data-aos-delay="350" data-aos-duration="700">
              <h4>Frontend</h4>
              <ul>
                <li>React.js</li>
                <li>Responsive Design</li>
                <li>Webcam Integration</li>
                <li>Real-time Processing</li>
              </ul>
            </div>
            <div className="tech-item" data-aos="flip-left" data-aos-delay="400" data-aos-duration="700">
              <h4>Backend</h4>
              <ul>
                <li>Flask (Python)</li>
                <li>TensorFlow Lite</li>
                <li>Computer Vision</li>
                <li>RESTful APIs</li>
              </ul>
            </div>
            <div className="tech-item" data-aos="flip-left" data-aos-delay="450" data-aos-duration="700">
              <h4>Security</h4>
              <ul>
                <li>AES Encryption</li>
                <li>Fernet Keys</li>
                <li>Secure Communication</li>
                <li>Data Protection</li>
              </ul>
            </div>
            <div className="tech-item" data-aos="flip-left" data-aos-delay="500" data-aos-duration="700">
              <h4>AI/ML</h4>
              <ul>
                <li>Gesture Recognition</li>
                <li>Hand Tracking</li>
                <li>Pattern Recognition</li>
                <li>Real-time Inference</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="values-section card" data-aos="fade-up" data-aos-delay="400" data-aos-duration="900">
          <h2 className="about-section-heading">Our Values</h2>
          <div className="values-grid">
            <div className="value-item" data-aos="fade-right" data-aos-delay="450" data-aos-duration="700">
              <div className="value-icon">♿</div>
              <h4>Accessibility</h4>
              <p>Designing for everyone, regardless of abilities</p>
            </div>
            <div className="value-item" data-aos="fade-up" data-aos-delay="500" data-aos-duration="700">
              <div className="value-icon">🔒</div>
              <h4>Privacy</h4>
              <p>Your communications are secure and private</p>
            </div>
            <div className="value-item" data-aos="fade-up" data-aos-delay="550" data-aos-duration="700">
              <div className="value-icon">🚀</div>
              <h4>Innovation</h4>
              <p>Cutting-edge technology for better communication</p>
            </div>
            <div className="value-item" data-aos="fade-left" data-aos-delay="600" data-aos-duration="700">
              <div className="value-icon">🤝</div>
              <h4>Inclusion</h4>
              <p>Building bridges between communities</p>
            </div>
          </div>
        </div>

        {/* Contact */}
        <div className="contact-section card" data-aos="fade-up" data-aos-delay="500" data-aos-duration="900">
          <h2 className="about-section-heading">Get in Touch</h2>
          <p>
            Have questions, suggestions, or want to contribute? We'd love to hear from you!
          </p>
          <div className="contact-info">
            <div className="contact-item" data-aos="fade-right" data-aos-delay="550">
              <span className="contact-icon">📧</span>
              <span>support@signcrypt.com</span>
            </div>
            <div className="contact-item" data-aos="fade-up" data-aos-delay="600">
              <span className="contact-icon">🌐</span>
              <span>www.signcrypt.com</span>
            </div>
            <div className="contact-item" data-aos="fade-left" data-aos-delay="650">
              <span className="contact-icon">📱</span>
              <span>+1 (555) 123-4567</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 